export default __webpack_public_path__ + "static/media/LedsitexSt.3f6933b0.ttf";